/* global window */

'use strict';

var callbackQueue = require('../lib/callbackQueue.js');
var Beacon = require('./hubPagesTracker.js');

window.phxConfigQueue.push(function () {
    callbackQueue('phxHubPagesBeaconQueue', Beacon);
});
